<template>
   <Forms ref="frmSearch"
           title="RELATÓRIO CONSULTA DE STATUS"
           :showHelp="true"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClearSection"
           v-on:Search="Search"
           >
            <div class="form-group row">

          <div style="width: 100%;">
            <label class="label-search">Situação:</label>
            <select v-model="form.situacao.value" class="form-control">
                <option v-for="data in obraStatus" :key="data.value" :value="data.value">{{data.text}}</option>
            </select>
          </div>

            <label class="label-search">Funcionário:</label>
            <autocomplete-z ref="favorecidoTypeahead"
                placeholder="Digite o nome do Funcionário"
                iconClass="fas fa-id-badge"
                :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                :debounceLength="3"
                :formField="form.funcionarioId"
                :returnCallback="true"
                v-on:search="onSearchFavorecido"
                v-on:changeCode="onChangeCodeFavorecido" />

            </div>
   </Forms>
</template>

<script>
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import formdata from './form'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '../../mixins/ExpenseMixin'
export default {
  name: 'ExpenseSearch',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      obraStatus: [
        { text: 'Todos', value: null },
        { text: 'Pendente', value: 0 },
        { text: 'Analise Documentos', value: 1 },
        { text: 'Avaliação', value: 2 },
        { text: 'Analise Final', value: 10 },
        { text: 'Analisada', value: 11 },
        { text: 'Diretor Técnico', value: 12 },
        { text: 'Diretor Administrativo', value: 14 },
        { text: 'Avaliada', value: 20 },
        { text: 'Paralisada', value: 15 },
        { text: 'Rejeitado Diretor Técnico', value: -1 }
      ],
      form: {
        funcionarioId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        situacao: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      formOriginal: {...formdata}
    }
  },
  mounted () {
    // this.GetStatusDespesa()
    this.form.situacao.value = null
  },
  methods: {
    Search () {
      this.$emit('search', { FuncionarioId: this.form.funcionarioId.value, SituacaoObra: this.form.situacao.value })
    },
    onClearSection () {
      this.form.situacao.value = null
      this.form.funcionarioId = {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      }
    }
  }
}
</script>

<style>
.label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/reports/consultstatus/components/ExpenseSearch/ExpenseSearch.vue